















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { zyScreenServer } from '@/api/installServer';
import DialogList from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box1/dialogList.vue';
import DialogAllList from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box1/dialogAllList.vue';
@Component({
  components: { DialogList, DialogAllList },
})
export default class Box2 extends Vue {
  private openFlag: any = true;

  private numForm: any = {
    risk_level_A: 0,
    risk_level_B: 0,
    risk_level_C: 0,
    risk_level_D: 0,
  };

  private areaId: any = '';

  mounted() {
    this.getData({});
  }
  getData(opts: any) {
    const userInfo: any = localStorage.getItem('userInfo');
    const info: any = JSON.parse(userInfo);
    this.areaId = opts.areaId || info.areaId;
    zyScreenServer
      .getRiskManagementCountData({
        areaId: this.areaId,
      })
      .then((res: any) => {
        if (res.data) {
          this.numForm = res.data;
        }
      })
      .catch((e: any) => {});
  }
  showRiskData(level: any, title: any) {
    const propData: any = {
      areaId: this.areaId,
      levelTitle: title,
      level: [level],
    };
    const refName = 'DialogListRef';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(propData);
  }
  showFlagClick() {
    this.openFlag = !this.openFlag;
    this.$emit('showModuleLeft', this.openFlag);
  }
  showRiskAllData() {
    (this.$refs.DialogAllListRef as any).showDialog(this.areaId);
  }
}
